<template>
    <div v-if="successTransfer">
        <div class="swap-modal-align-center">
            <span class="sg-vrm-icon_146_restart_32px vrm-modal__title-icon"></span>
            <div
                class="vrm-modal__title"
                v-html="
                    $t(`general.confirm_replace_modal.last_step.almost`, {
                        i18nFallback: 'Almost done! Please restart your replacement GX device',
                    })
                "
            ></div>
        </div>
        <div class="vrm-modal__content swap-modal-align-center">
            <div
                class="vrm-modal__text"
                v-html="
                    $t(`general.confirm_replace_modal.last_step.final_step`, {
                        i18nFallback:
                            'As a final step you need to <b>manually restart</b> your replacement GX device.<br/>How to do this can be found in the manual of the device.',
                    })
                "
            ></div>
            <br />
            <button class="sg-btn sg-blue" @click="confirmClose()">
                {{
                    $t(`general.confirm_replace_modal.last_step.got_it`, {
                        i18nFallback: 'Got it, close this window',
                    })
                }}
            </button>
        </div>
    </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component({
    props: {
        successTransfer: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        confirmClose() {
            this.$parent.confirmClose();
        },
    },
})
@AngularLocaleBundle('general')
export default class VrmSwapDevicesStepResult extends Vue {}
</script>
